<div class="calendar-view-layout-container">
    <smart-icon class="item-icons light" size="24" name="{{iconName}}" (click)="showCalendarLayoutContextMenu($event)">
    </smart-icon>
    <tam-context-menu [config]="calendarLayoutContextMenuConfig"></tam-context-menu>
</div>